import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import { HideBC } from "@my-dld/components/BreadCrumb";
import { DateUtil, I8N, LocaleUtil } from "@eres/core";
import { getName } from "@10x/sso";
import { dispatch, navigate, replaceNavigate } from "@my-dld/utils/StoreUtils";
import { SSOApi } from "@eres/ssoapi";
import { hideLoading, showLoading } from "@my-dld/utils/UIUtils";
import { exToMessage, profile } from "@eres/ssoapi/api";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { ApplicationProfile } from "@eres/ssoapi/entities";
import { getAppServices } from "@10x/coreapp";
import Actions from "@my-dld/actions";
import moment from "moment/moment";
import { formatDate } from "@eres/core/dist/DateTime";

interface State {
	application: any;
	applicationProfiles?: any;
	selectedProfileId?: number;
	selectedUserTypeId?: number;
}

class AppProfiles extends Component<RoutedViewProps, State> {
	constructor( props: any ) {
		super( props );
		const application = getAppServices().storeService.getStore().getState().User.application;
		this.state = {
			application: application,
			selectedProfileId: 0,
			selectedUserTypeId: 0
		};
	}

	componentDidMount() {
		const application = getAppServices().storeService.getStore().getState().User.application;
		// CALL API FROM ALI , if response is success , proceed with the below code
		const verticalAppUrl = LocaleUtil.getLocalValue( application?.verticalAppProfileUrl );
		if (verticalAppUrl && verticalAppUrl.length) {
			const appName = verticalAppUrl.split("/").pop();
            showLoading();
			SSOApi.profile.fetchProfiles(appName).then( r => {

				if (r.response.profiles) {
                    if (r.response.profiles && r.response.profiles.length === 1) {
                        const profile = r.response.profiles [0];
	                    dispatch( Actions.SET_SELETEDPROFILE_ID, profile.userAccountId );
	                    this.setState({applicationProfiles: r.response.profiles, selectedProfileId: profile.userAccountId, selectedUserTypeId: profile.userTypeId}, () => {
							if (application.fetchNDA) {
								this.onSelectProfile(profile);
								// navigate("/mydld/nda", "", {application: this.state.application, profile: profile, selectedProfileId: profile.userAccountId});
							} else {
								this.onSelectProfile(profile);
								replaceNavigate( "/mydld/dashboard" );
							}
                        })
                    } else {
	                    this.setState({applicationProfiles: r.response.profiles});
                    }
				}
				hideLoading();
			})
			.catch( e => {
				hideLoading();
				return exToMessage( e )
				.then( SSOApi.profile.handleProfileException )
				.then( correction => {
					const isCorrected = correction.action.task( correction.data );
					if ( isCorrected ) {
						hideLoading();
						// replaceNavigate( "/mydld/profile" );
					}
					return Promise.reject( correction.error );
				} ).catch( e => {
					hideLoading();
					exToMessage( e ).then( message => {
						hideLoading();
						let key = "newPwd";
						if ( message.src && message.src === "old" ) {
							key = "current";
						}
						// this.setError( key, message.error );
					} );
				} );

			} );
		}
	}

	authenticateMe = () => {
		profile.me().then( profile => {
			if (this.state.application.fetchNDA) {
				setTimeout(() => {
					replaceNavigate("/mydld/nda", "", {application: this.state.application, profile: profile, selectedProfileId: this.state.selectedProfileId});
				}, 100);
			} else {
				const url = LocaleUtil.getLocalValue( this.state.application?.url );
				if ( url ) {
					hideLoading();
					if ( url.startsWith( "#" ) ) {
						let xp = url.substr( 1 );
						navigate( xp );
					} else {
						window.open( url + "?ln=" + I8N.locale(), "_" + this.state.application.id );
					}
				}
				replaceNavigate( "/mydld/dashboard" );
			}
		} ).catch( e => {
			console.log("catche", e);
			return exToMessage( e )
			.then(SSOApi.profile.handleProfileException)
			.then( correction => {
				dispatch( Actions.SET_SHOW_NDA, true );
				setTimeout(() => {
					replaceNavigate("/mydld/profile/verify_account", "", {showNDA: true});
				}, 100)
				console.log("profile correction", correction);
				const isCorrected = correction.action.task( correction.data );
				// if ( isCorrected ) {
				// 	if ( onProfile ) onProfile( correction.data.data );
				// 	return Promise.resolve();
				// }
				return Promise.reject( correction.error );
			} )
			.catch( () => {
				// if ( onError ) onError( e );
			} );

		} );
	}
	onSelectProfile = (profile?: any) => {
		if (this.state.selectedProfileId !== 0) {
			showLoading();
			SSOApi.profile.selectProfile(  this.state.selectedProfileId + "" ).then( r => {
				if(r.ok) {
					this.authenticateMe();
				}
			} )
			.catch( e => {
				hideLoading();
				return exToMessage( e )
				.then( SSOApi.profile.handleProfileException )
				.then( correction => {
					const isCorrected = correction.action.task( correction.data );
					if ( isCorrected ) {
						hideLoading();
						// replaceNavigate( "/mydld/dashboard" );
					}
					return Promise.reject( correction.error );
				} ).catch( e => {
					hideLoading();
					exToMessage( e ).then( message => {
						hideLoading();
						let key = "newPwd";
						if ( message.src && message.src === "old" ) {
							key = "current";
						}
						// this.setError( key, message.error );
					} );
				} );

			} )
			.finally( () => {
				this.authenticateMe();
			});
		}
	}

	render() {
		return (
			<React.Fragment>
				<HideBC/>
				<div className="dashboard-banner hide">
					<div className="container">
						<div className="sso-dashboard-title">
							<span>{ Strings.one_account_for_all }</span>
							<span>
                                { Strings.one_account_desc }
                            </span>
						</div>
					</div>
				</div>
				<div className="container b-user-dashboard ">

					<div className="dashboard-user-title hide">
						<h5>
							{ Strings.welcome } { LocaleUtil.getLocalValue( getName() ) }
							<small>{ DateUtil.formatDate( new Date(), "Do MMMM YYYY" ) }</small>
						</h5>
						<div className="dashboard-user-action">
							<button
								type="button" className="btn btn-sm" onClick={ () => {
								navigate( "/mydld/profile" );
							} }>
								<i className="icon-profile"/>
								<span>{ Strings.profile }</span>
							</button>
							<button
								type="button" className="btn btn-sm" onClick={ () => {
								if ( window.showMyDLDLogout ) window.showMyDLDLogout();
							} }>
								<i className="icon-logout"/>
								<span>{ Strings.sign_out }</span>
							</button>
						</div>
					</div>
					<div className="row hide">
						<div className="card-header col-md-12">
							<div>{ Strings.dld_account_dashboard }</div>
							<small>
								{ Strings.accounts_linked_with_profile }
							</small>
						</div>
					</div>

					{/*HTML:: Multi user found*/}
                    {this.state.applicationProfiles && <div className="auth-container" id="ssoAppProfileWrapEjari">
                        <div className="auth-container-inner multi-profile-inner">
                            <button type="button" className="btn btn-grey mb-3" onClick={ () => {
	                            replaceNavigate( "/mydld/dashboard" );
                            } }>{Strings.back}</button>
							<div className="auth-title">
								<span>{Strings.multiple_profiles_found + " ( " + this.state.applicationProfiles.length + " )"}</span>
							</div>
							<div className="data-availibility-msg">
								{Strings.multiple_profiles_description}
							</div>
							<div className="card card-sso-profile">
								{this.state.applicationProfiles && this.state.applicationProfiles.map((item: ApplicationProfile) => {
									const isSelected = ((item.userTypeId === this.state.selectedUserTypeId) && (item.userAccountId === this.state.selectedProfileId));
									return <div className={isSelected ? "card-sso-profile-in active" : "card-sso-profile-in"}>
										<div className="card-header">
											{/*<div className="sso-app-avatar">*/}
											{/*	<div className="avatar">*/}
											{/*		<img*/}
											{/*			src={ AppConstants.rootUrl + "assets/img/ss-profile-avatar.svg/" } // item.avatarUrl*/}
											{/*			className="rounded-circle" alt="user image"/>*/}
											{/*	</div>*/}
											{/*</div>*/}
                                            <div className="card-body">
												<div className="sso-profile-name">
													<span className="card-title">{Strings.username}</span>
													<span className="card-sub-title">{item.userName}</span>
                                                </div>
												{item.additionalInfo && item.additionalInfo.map((infoItem) => {
													return <div className="sso-profile-name">
														<span className="card-title">{I8N.isRTL() ? infoItem.key.arabicName : infoItem.key.englishName}</span>
														<span className="card-sub-title">{I8N.isRTL() ? infoItem.value.arabicName : infoItem.value.englishName}</span>
													</div>
                                                })}
											</div>
											<div className="form-check">
												<input className="form-check-input" type="radio" name="radioSSOUser" id={item.userAccountId + ""} checked={isSelected} onChange={() => {
													dispatch( Actions.SET_SELETEDPROFILE_ID, item.userAccountId );
													this.setState({selectedProfileId: item.userAccountId, selectedUserTypeId: item.userTypeId})
												}}/>
												<label className="form-check-label" htmlFor="radioSSOUser1">
													<span className="sr-only">Default radio</span>
												</label>
											</div>
										</div>

									</div>
								})}
							</div>
							{this.state.selectedProfileId !== 0 && <button type="button" className="btn btn_1 " id="btn-sso-proceed" onClick={this.onSelectProfile}>{Strings.proceed_to_application}</button>}
						</div>
					</div>
					}
				</div>
			</React.Fragment>);
	}

	private onContinue = () => {

	};


}

export default AppProfiles;
